"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "StarFilled___StyledSvg",
  componentId: "sc-4k2a6-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function StarFilled(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.939 7.27a.8.8 0 00-.74-.496h-4.305l-2.179-4.367c-.271-.543-1.16-.543-1.431 0L7.105 6.774H2.8a.8.8 0 00-.566 1.37l3.667 3.675-1.47 5.159a.803.803 0 00.297.868.797.797 0 00.915.019L10 14.955l4.356 2.91a.797.797 0 00.916-.02.803.803 0 00.297-.867l-1.47-5.16 3.666-3.675a.804.804 0 00.174-.874z",
    fill: "currentColor"
  }));
}

var _default = StarFilled;
exports["default"] = _default;